import { useState } from 'react';
import { apiClient } from '../../api_actions';

const fetchSummaryData = async (startAndEndUnixDatesParams, isInternal) => {
    const endpoint = isInternal ? 'internalsummary' : 'summary';
    try {
        const res = await apiClient.post(`read/${endpoint}?${startAndEndUnixDatesParams()}`);
        if (res) {
            return res;
        }
        return null;
    } catch (error) {
        console.error(`Failed to load ${endpoint} data:`, error);
        return null;
    }
};

const fetchPreloadData = async () => {
    try {
        const res = await apiClient.post(`read/preload`);
        if (res) {
            return res;
        }
        return null;
    } catch (error) {
        console.error('Failed to load preload data:', error);
        return null;
    }
};

export const useAISummaryLogic = ({ startAndEndUnixDatesParams, onLoadingChange, isInternal = false }) => {
    const [summary, setSummary] = useState(null);
    const [summaryCollapsed, setSummaryCollapsed] = useState(false);

    const setLoading = (value) => {
        if (onLoadingChange) onLoadingChange(value);
    };

    const triggerFetch = async () => {
        setLoading(true);
        setSummaryCollapsed(false);
        const data = await fetchSummaryData(startAndEndUnixDatesParams, isInternal);
        setSummary(data);
        setLoading(false);
    };

    const triggerPreload = async () => {
        setLoading(true);
        const data = await fetchPreloadData();
        setSummary(data);
        setLoading(false);
    };

    const toggleSummaryCollapsed = () => setSummaryCollapsed((prev) => !prev);

    return {
        summary,
        summaryCollapsed,
        triggerFetch,
        triggerPreload,
        toggleSummaryCollapsed,
    };
};
